import React from "react";
import { useI18n, I18nChildContext } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";
// eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
import { useStore, useActions } from "../../../store";
import { actions as OrderActions } from "../../../store/order/actions";
import ErrorAlert from "../ErrorAlert";
import NotAvailableIllustration from "../../../assets/illustrations/not-available.svg";
import { useClientFetch } from "../../../hooks/useClientFetch";
import { UIOrder } from "@flights/types";
import { assert } from "../../../utils/assert";
import styles from "./PostBookingPaymentInnerLoader.module.css";

interface Props {
  token: string;
  children?: React.ReactNode;
  loadingSkeleton?: React.ReactNode;
}

const PostBookingPaymentInnerLoader: React.FunctionComponent<Props> = (props) => {
  const { children, loadingSkeleton } = props;
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const orderActions = useActions(OrderActions);
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const store = useStore();
  const i18n = useI18n() as I18nChildContext;

  const addOnOrderId = new URLSearchParams(location.search).get("aoid");
  if (!addOnOrderId) {
    throw new Error("No Add-On Order ID found");
  }

  useClientFetch(`/api/order/${props.token}?addOnOrderId=${addOnOrderId}&includeAvailableExtras=1&pb=1`, {
    shouldGenerateNewClientsidePayload: true,
    fetch: orderActions.fetch,
    error: orderActions.fetchError,
    success: (order: UIOrder) => {
      const addOnOrder = order.addOnOrders?.find((addOnOrder) => addOnOrder.addOnOrderId === addOnOrderId);
      assert(addOnOrder);
      orderActions.setAddOnOrder(addOnOrder);
      orderActions.fetchSuccess(order);
    },
    cache: false
  });

  if (store.order.fetchStatus === "failed") {
    return (
      <div>
        <ErrorAlert
          illustration={<NotAvailableIllustration />}
          title={i18n.trans(t("flights_error_timeout_header"))}
          body={i18n.trans(t("flights_error_timeout_subheader"))}
          buttonLabel={i18n.trans(t("flights_refresh_action"))}
          onClick={() => window.location.reload()}
        />
      </div>
    );
  }
  return (
    <>
      {store.order.fetchStatus === "success" ? (
        <React.Fragment>{children}</React.Fragment>
      ) : loadingSkeleton ? (
        <React.Fragment>{loadingSkeleton}</React.Fragment>
      ) : (
        /*eslint-disable-next-line flights/no-unassigned-todo-comments*/
        // TODO(aeprev): tag
        <div className={styles.loading}>{i18n.trans(t("flights_select_in_progress"))}</div>
      )}
    </>
  );
};
export default PostBookingPaymentInnerLoader;
